import toast from 'react-hot-toast';

/**
 * Error handling utilities for consistent error management
 */

/**
 * API 에러 메시지 추출
 * Phase 2 표준화: error가 문자열 또는 { code, message } 객체일 수 있음
 * @param error - API 응답의 error 필드
 * @returns 에러 메시지 문자열
 */
export const extractErrorMessage = (error: any): string => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (typeof error === 'object') {
    if (error.message) return error.message;
    if (error.code) return error.code;
    return '';
  }
  return String(error);
};

/**
 * API 응답에서 에러 메시지 추출
 * @param responseData - API 응답 데이터
 * @param defaultMessage - 기본 메시지
 * @returns 에러 메시지
 */
export const getApiErrorMessage = (responseData: any, defaultMessage: string = 'An error occurred'): string => {
  if (!responseData) return defaultMessage;

  // error 필드가 있으면 추출
  if (responseData.error) {
    return extractErrorMessage(responseData.error);
  }

  // message 필드가 있으면 사용
  if (responseData.message) {
    return responseData.message;
  }

  return defaultMessage;
};

/**
 * Handle authentication errors with toast notifications
 * @param error - Error object from async thunk
 * @param defaultMessage - Default message if error details not available
 * @returns Error message for Redux rejection
 */
export const handleAuthError = (error: any, defaultMessage: string = 'Operation failed'): string => {
  const errorMessage = getApiErrorMessage(error.response?.data, error.message || defaultMessage);
  toast.error(errorMessage);
  return errorMessage;
};
